import { Modal } from "react-bootstrap";
import backIcon from "../../../images/arrow-left-solid.png";
import MethodModalPage from "./MethodModalPage.js";
import DeliveryAddressModalPage from "./DeliveryAddressModalPage.js";

export default function PickupDeliveryModal(props) {

    let modalBody;

    if (props.pickupOrDelivery.PickupDeliveryModal.ModalPageShown == 'Method') {
        modalBody = 
            <>
                <div className="modal-header">
                    <h1 className="modal-title fs-5">How would you like to order?</h1>
                </div>
                <MethodModalPage
                    handleSelectMethodPickupDeliveryModal={props.handleSelectMethodPickupDeliveryModal}
                 />
            </>
    } else if (props.pickupOrDelivery.PickupDeliveryModal.ModalPageShown == 'Address') {
        modalBody = 
        <>
            <div className="modal-header justify-content-start">
                <button type="button" className="btn btn-light rounded-pill" onClick={props.handleBackAddressToMethodClick} disabled={props.pickupOrDelivery.DeliveryAddressError.ButtonsDisabled} >
                    <img src={backIcon} alt="Back" title="Back" style={{width: "20px"}}></img>
                </button>
                <h1 className="modal-title fs-5">&emsp;Confirm your delivery address</h1>
            </div>
            <DeliveryAddressModalPage
                pickupOrDelivery={props.pickupOrDelivery}
                handleChangeAddressFields={props.handleChangeAddressFields}
                handleSubmitAddressFields={props.handleSubmitAddressFields}
            />
        </>
    }

    return (
        <>
            <Modal show={props.pickupOrDelivery.PickupDeliveryModal.ModalIsShown} backdrop="static" keyboard={false}>
                {modalBody}     
            </Modal>
        </>
    )
}